import React from 'react';
import InstructorCard from './InstructorCard';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLocalizedValue, siteContent } from '../../data/siteContent';

const InstructorsSection = () => {
  const { language } = useLanguage();
  const instructors = siteContent.instructors.items;
  const title = getLocalizedValue(siteContent.navigation.coaches, language);

  return (
    <section className="section instructors-section" id="coaches">
      <div className="container">
        <h2 className="section-title">{title}</h2>
        <div className="instructors-grid">
          {instructors.map((instructor) => (
            <InstructorCard key={instructor._id} instructor={instructor} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstructorsSection;
